import { createSelector } from '@reduxjs/toolkit'
import { OptimizelyFeatureFlags } from 'constants/optimizely'

export const selectIsLebtHotelLoyaltyEnabled = createSelector(
  (state: App.State) => state.optimizely.optimizelyFeatureFlags,
  (optimizelyFeatureFlags): boolean => {
    return !!(optimizelyFeatureFlags[OptimizelyFeatureFlags.lebt_hotel_loyalty])
  },
)
